import { HELP_FEEDBACK_EMAIL } from '../config';

/**
 * A mailto: link for "Report a problem", with what the team needs to follow it up
 * already filled in: the page, the person's highest role and the browser. Nothing
 * is sent until the person sends the email themselves.
 */
export function feedbackMailto(opts: { subject: string; intro: string; page: string; role: string; to?: string }): string {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const body = [
    opts.intro,
    '',
    '',
    '---',
    `Page: ${opts.page}`,
    `Role: ${opts.role}`,
    `Browser: ${ua}`,
  ].join('\n');
  return `mailto:${opts.to || HELP_FEEDBACK_EMAIL}?subject=${encodeURIComponent(opts.subject)}&body=${encodeURIComponent(body)}`;
}
